import { Role } from "constant/Role"

const LS_KEY = "procurementDevOverride"

const envEnabled = process.env.REACT_APP_PROCUREMENT_DEV === "true"

const readLocalStorageOverride = () => {
  if (typeof window === "undefined") return null
  try {
    const raw = window.localStorage.getItem(LS_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === "object" ? parsed : null
  } catch {
    return null
  }
}

export const applyProcurementDevOverride = (procurement) => {
  const ls = readLocalStorageOverride()
  if (!envEnabled && !ls) return procurement

  const envDefault = envEnabled
    ? {
        requesterEnabled: true,
        eligibleRoles: [Role.PROCUREMENT],
        defaultRegion: "North",
      }
    : {}

  return { ...procurement, ...envDefault, ...(ls || {}) }
}
